import Vue from "vue"
import DatePicker from 'vue2-datepicker'
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
import moment from 'moment'
import { mounted } from "vue-simple-suggest";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default {
  components: {
    DatePicker,
    Paginate
  },
  data: function () {
    return {
      busy: false,
      loading: false, // สถานะกำลัง export (block ปุ่มกันกดซ้ำ)
      date_start: null,
      date_end: null,
      perPage: 6,
      sortBy: 'name',
      currentPage: 1,
      // object สำหรับ widget Paginate (สร้างเองฝั่ง client — ข้อมูลโหลดมาครบแล้ว แค่แบ่งตอน render)
      currentData: { current_page: 1, last_page: 1, to: 0, total: 0 },
      sortDesc: false,
      totalItem: 0,
      apiStatus: 'กรุณาระบุวันที่และกดปุ่มแสดงข้อมูลเพื่อค้นหาข้อมูล',
      fields: [
        {
          key: 'index',
          label: '#',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
        },
        { key: 'customer_code', label: 'รหัสลูกค้า', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'customer_name', label: 'ชื่อลูกค้า', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'bill_seller', label: 'พนักงานขาย', thClass: 'font-weight-bold', tdClass: 'td-top' },
        // { key: 'sum_quantity', label: 'รวมจำนวนเมตร', thClass: 'font-weight-bold', tdClass: 'td-top' },
        // { key: 'sum_total_price', label: 'รวมยอดขาย', thClass: 'font-weight-bold', tdClass: 'td-top' },
        // { key: 'พนักงานขาย', label: 'พนักงานขาย', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'details', label: 'รายละเอียด', thClass: 'font-weight-bold', tdClass: 'td-top' }
      ],
      detailFields: [
        {
          key: 'index',
          label: '#',
          thClass: 'font-weight-bold text-xs-1/2',
          tdClass: 'td-top text-xs-1/2',
        },
        { key: 'รหัสสินค้า', label: 'รหัสสินค้า', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'รายละเอียดสินค้า', label: 'รายละเอียดสินค้า', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'PU/PE', label: 'PU/PE', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'Size', label: 'Size', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'รหัสสมั่นสาขา', label: 'รหัสม้วนสาขา', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'Color', label: 'Color', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'Brand', label: 'Brand', thClass: 'font-weight-bold', tdClass: 'td-top' },
        // { key: 'พนักงานขาย', label: 'พนักงานขาย', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'จำนวนเมตร', label: 'จำนวนเมตร', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'ยอดขาย', label: 'ยอดขาย', thClass: 'font-weight-bold', tdClass: 'td-top' },
        { key: 'ราคาต่อหน่วย', label: 'ราคาต่อหน่วย', thClass: 'font-weight-bold', tdClass: 'td-top' }
        
      ],
      // Inner table columns (per‐document)
      docFields: [
        { key: 'index', label: '#', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2 td-top' },
        { key: 'id', label: 'เลขที่เอกสาร', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        { key: 'created_at', label: 'วันที่สร้าง', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        { key: 'bill_duedate', label: 'วันครบกำหนด', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        { key: 'customer_code', label: 'รหัสลูกค้า', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        { key: 'customer', label: 'ชื่อลูกค้า', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        // { key: 'bill_before_vat', label: 'ยอดก่อน VAT', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        // { key: 'bill_value_added_tax', label: 'VAT', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  },
        { key: 'total_price', label: 'ยอดรวม', thClass: 'font-weight-bold text-xs-1/2', tdClass: 'text-xs-1/2'  }
      ],
      items: [
      ],
      form: {
        roll: null,
        start_date: new Date(moment().startOf('month').format('YYYY-MM-DD')),
        end_date: new Date(moment().endOf('month').format('YYYY-MM-DD'))
      },
      seller_list: [],
      sum: 0,
    }
  },
  computed: {
    rows() {
      return this.items.length
    },
    // render เฉพาะหน้าปัจจุบัน — ช่วงยาว ๆ ลูกค้าหลายร้อยราย x ตารางลูก ถ้า render ทีเดียว browser ค้าง
    pagedItems() {
      const start = (this.currentPage - 1) * this.perPage
      return this.items.slice(start, start + this.perPage)
    }
  },
  methods: {
    async onInitData() {
      try {
        const item = this.items
        this.items = []
        this.busy = true
        this.apiStatus = 'กำลังค้นหาข้อมูล..'

        const res = await this.$axios.get(
          this.$host + "/api/v1/report/pu?roll=" + encodeURIComponent(this.form.roll) + "&keyword_startdate=" + moment(this.form.start_date).format('YYYY-MM-DD') + "&keyword_enddate=" + moment(this.form.end_date).format('YYYY-MM-DD'),
        )

        const data = res.data

        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.items = data.data
        this.sum = data.total
        this.currentPage = 1
        this.currentData = {
          current_page: 1,
          last_page: Math.max(1, Math.ceil(this.items.length / this.perPage)),
          to: this.items.length,
          total: this.items.length,
        }

      } catch (error) {
        this.busy = false
        this.apiStatus = 'ไม่พบข้อมูล'
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    onPaginate(page) {
      this.currentPage = page
      this.currentData.current_page = page
    },
    async onLoadEmployee() {
      try {
        this.loading = true;
        const res = await this.$axios.get(
          this.$host + "/api/v1/document/quotation/branch/employee"
        );

        const newObj = { name: "--- ทั้งหมด ---", id: null };
        this.seller_list = res.data;

        this.seller_list.unshift(newObj)

        this.loading = false;
      } catch (error) {
        this.loading = false;

        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
    exportPDFReport() {
      this.loading = true;
      setTimeout(async () => {
        this.loading = true

        const result = await this.$axios.get(
          this.$host + "/api/v1/report/pdf/customer?sale_id=" + (this.form.sale_id ? this.form.sale_id : "") + "&keyword_startdate=" + moment(this.form.start_date).format('YYYY-MM-DD') + "&keyword_enddate=" + moment(this.form.end_date).format('YYYY-MM-DD'),

          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
            responseType: "blob",
          }
        );
        const blob = new Blob([result.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(blob);
        var isSafari = /^((?!chrome|android).)*safari/i.test(
          navigator.userAgent
        );
        if (isSafari) {
          window.open(objectUrl)
          // const link = document.createElement('a')
          // link.href = objectUrl2
          // link.setAttribute('download', 'ใบเสนอราคา ' +  + '.pdf')
          // document.body.appendChild(link)
          // link.click()

          this.loading = false;
        } else {
          window.open(
            objectUrl,
            "targetWindow",
            `toolbar=no,
           location=no,
           status=no,
           menubar=no,
           scrollbars=yes,
           resizable=yes,
           width=SomeSize,
           height=SomeSize`
          );
          this.loading = false;
        }
        // URL.revokeObjectURL(objectUrl);
      }, 1000);
    },
    async exportExcelReport() {
      try {
        this.loading = true;

        const response = await this.$axios.get(
          this.$host + "/api/v1/report/excel/pu?keyword=" + encodeURIComponent(this.form.keyword ? this.form.keyword : "") + "&keyword_startdate=" + moment(this.form.start_date).format('YYYY-MM-DD') + "&keyword_enddate=" + moment(this.form.end_date).format('YYYY-MM-DD'),
          { responseType: 'blob' }
        );

        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.form.start_date.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }) + ' ถึง ' + this.form.end_date.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
        }) + `PU report.xls`);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Cleanup after click

      } catch (error) {
        this.onExceptionHandler(error?.response?.data?.message || "An error occurred while downloading the file.");
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    await this.onLoadEmployee()
  }
}